import React from 'react';

import './legacy-navigation-icons.css';

const legacyIconNames = new Set([
    'account_circle',
    'date_range',
    'insert_chart',
    'lock',
    'people',
    'settings',
    'view_quilt',
]);

export const LegacyNavigationIcon = ({ icon }: { icon: string }) => {
    if (!legacyIconNames.has(icon)) {
        return null;
    }

    return (
        <i
            className="opus-navigation-shell__icon opus-legacy-material-icon"
            aria-hidden="true"
        >
            {icon}
        </i>
    );
};

export default LegacyNavigationIcon;
